module.exports = __webpack_public_path__ + "img/17.59c9452e.jpg";